// extracted by mini-css-extract-plugin
export var borderRadius = "_9j-4";
export var large = "_9j-3";
export var logoContainer = "_9j-0";
export var nameLogo = "_9j-2";
export var small = "_9j-1";